module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.status === 'FAILED') ? _c('b-row', [_c('b-col', [_c('b-alert', {
    attrs: {
      "show": _vm.status === 'FAILED',
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status !== 'RUNNING') ? _c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "p-0"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.status === 'SUCCESS' && _vm.message !== null,
      "dismissible": "",
      "variant": "warning"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex flex-row justify-content-end p-0"
  }, [_c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Save Query"
    },
    on: {
      "click": function($event) {
        _vm.saveDialog.visible = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "save"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.totalRows,
      "per-page": _vm.rowsPerPage
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-skeleton-wrapper', {
    attrs: {
      "loading": _vm.status === 'RUNNING'
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function() {
        return [_c('b-skeleton-table', {
          attrs: {
            "animation": "throb",
            "rows": 5,
            "columns": 4,
            "table-props": {
              hover: true,
              bordered: true,
              striped: true
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), (_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "no-border-collapse": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "small": "",
      "sticky-header": "",
      "items": _vm.table,
      "fields": _vm.fields,
      "current-page": _vm.pageNo,
      "per-page": _vm.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": 'save-dialog-' + _vm.query.id,
      "centered": "",
      "title": "Save Query"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('p', {
          staticClass: "float-left"
        }), _vm._v(" "), _c('b-button-group', {
          staticClass: "float-right"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.saveQuery()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-secondary"
          },
          on: {
            "click": function($event) {
              _vm.saveDialog.visible = false
            }
          }
        }, [_vm._v("Cancel")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.saveDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "visible", $$v)
      },
      expression: "saveDialog.visible"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "name-id",
      "label": "Name:",
      "label-for": "name",
      "description": "Name the query"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Query Name"
    },
    model: {
      value: (_vm.saveDialog.name),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "name", $$v)
      },
      expression: "saveDialog.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "description-id",
      "label": "Description:",
      "label-for": "description",
      "description": "Describe the query"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Query Description",
      "rows": "5"
    },
    model: {
      value: (_vm.saveDialog.description),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "description", $$v)
      },
      expression: "saveDialog.description"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c83117ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Query.vue
// module id = 2147
// module chunks = 1